import { z } from 'zod';

export const CatalogGovernanceFieldsSchema = z.object({
  is_locked: z.boolean().optional(),
  managed_by_org_id: z.string().uuid().nullable().optional(),
});

export type CatalogGovernanceFields = z.infer<typeof CatalogGovernanceFieldsSchema>;

export const isCatalogRowLocked = (row: CatalogGovernanceFields | null | undefined): boolean =>
  row?.is_locked === true || row?.managed_by_org_id != null;

export const editableCatalogRowIds = <T extends CatalogGovernanceFields & { id: string }>(
  rows: readonly T[],
): string[] => rows.filter((row) => !isCatalogRowLocked(row)).map((row) => row.id);